import React from "react";
import { Link } from "react-router-dom";

const InternalServerError = (props) => {
  return (
    <>
      <div>
        <header className="uxf-header navbar m-0 h-[80px] min-w-full">
          <a aria-label="error page" href="#">
            <div className="uxf-logo"></div>
          </a>
        </header>
      </div>
      <div className="home h-[100px] max-w-full">
        <span>
          <h4 className="text-center mt-[5%]">
            <b>
              A system error occurred. Please try again later or contact your
              FOM Support.
            </b>
          </h4>
        </span>
      </div>
    </>
  );
};

export default InternalServerError;
